// extracted by mini-css-extract-plugin
export default {"label":"label_label__Hn7C6"};